import React, { useState, useEffect } from 'react';
import { renderPatientCard } from '../../Components/Common Components/CommonComponents';
import { Box, Button, Modal, IconButton, TextField, Tooltip, Typography } from '@mui/material';
import { ImagePaths } from '../../Utility/ImagePaths';
import { DataGrid } from '@mui/x-data-grid';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const ApproverListPopup = React.memo((props) => {
    const [state, setState] = useState({
        approverList: props.approverList || [],
        dupApproverList: props.approverList || [],
        approverDate: new Date(),
        approverDatePickerOpen: false,
        searchApproverList: '',
        approverPage: 0,
        approverPageSize: 10,
    })

    useEffect(() => {
        const handler = setTimeout(() => {
            const query = state.searchApproverList?.trim()?.toLowerCase();
            const dupList = state.dupApproverList || [];

            const filteredList = query
                ? dupList.filter(item =>
                    [item?.patient_name, item?.patient_mobile_number, item?.patient_account_number]
                        .some(field => (field || '').toLowerCase().includes(query))
                )
                : dupList;

            updateState({ approverList: filteredList });
        }, 400);

        return () => clearTimeout(handler);
    }, [state.searchApproverList]);

    const updateState = (newData) => {
        setState((prevState) => ({
            ...prevState,
            ...newData
        }))
    }

    const { module_name, modulePaths, history, openApproverList, approverLoad, onClose } = props;

    const handleCreateBill = (data) => {
        const targetPath = modulePaths[module_name];
        if (data?.ip_admission_id) {
            history?.push({
                pathname: "/IPHome/FinalSettlement",
                state: {
                    Patient_details: data, approver_id: data?.approver_id,
                    ip_admission_id: data?.ip_admission_id, fromApprover: true
                }
            })
        }
        else {
            history?.push({
                pathname: targetPath, state: {
                    patientDetails: data, appointment_id: data?.appointment_id,
                    invoiceId: data?.op_bill_id, fromApprover: true,
                    pending_list_id: data?.id, approver_id: data?.approver_id,
                    requested_from: data?.request_from
                }
            });
            setTimeout(() => history?.push({ pathname: targetPath, state: {} }), 5000);
        }
    }

    try {
        state.approverList?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'patient_details', headerName: 'Patient Details', flex: 0.3,
                renderCell: (params) => {
                    return (
                        <Box>{renderPatientCard(params?.row)}</Box>
                    )
                }
            },
            {
                field: 'requested_details', headerName: 'Requested Details', flex: 0.2,
                renderCell: (params) => {
                    const opNumber = params?.row?.request_number
                    return (
                        <Box>
                            {opNumber ? opNumber?.length > 15 ?
                                <Tooltip placement='top' title={opNumber}><Typography fontSize={'0.9rem'} fontWeight={600}>{'...' + opNumber?.slice(-15)}</Typography></Tooltip> :
                                <Typography fontSize={'0.9rem'} fontWeight={600}>{opNumber}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'request_type', headerName: 'Request Type', flex: 0.2,
                renderCell: (params) => {
                    const orderInvoice = 'Concession'
                    const reqDate = `${params?.row?.request_date} ${params?.row?.request_time}`
                    return (
                        <Box>
                            {orderInvoice ? orderInvoice?.length > 15 ?
                                <Tooltip placement='top' title={orderInvoice}><Typography fontSize={'0.9rem'} fontWeight={600}>{'...' + orderInvoice?.slice(-15)}</Typography></Tooltip> :
                                <Typography fontSize={'0.9rem'} fontWeight={600}>{orderInvoice}</Typography> : '-'}
                            <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{reqDate}</Typography>
                        </Box>
                    )
                }
            },
            {
                field: 'requested_by', headerName: 'Raised By', flex: 0.2,
                renderCell: (params) => {
                    const doctorName = params?.row?.requested_by
                    return (
                        <Box>
                            {doctorName ? doctorName?.length > 15 ?
                                <Tooltip placement='top' title={doctorName}>
                                    <Typography fontSize={'0.9rem'} fontWeight={600}>{doctorName?.slice(0, 15) + '...'}</Typography>
                                </Tooltip> :
                                <Typography fontSize={'0.9rem'} fontWeight={600}>{doctorName}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'action', headerName: 'Action', flex: 0.1,
                renderCell: (params) => {
                    return (
                        <Box>
                            {targetPath && (
                                <IconButton
                                    onClick={() => {
                                        onClose();
                                        updateState({
                                            approverDate: new Date(),
                                            approverDatePickerOpen: false,
                                            searchApproverList: ''
                                        });
                                        handleCreateBill(params.row);
                                    }}
                                >
                                    <Box component={'img'} src={ImagePaths.CreateBill.default} height={'1.5dvw'} width={'1.8dvw'} />
                                </IconButton>
                            )}
                        </Box>
                    )
                }
            },
        ]
        return (
            <Modal sx={{ border: "none", outline: "none" }} open={openApproverList}>
                <Box component={'div'} className='com_billing_popup' id="emedhub_popup_mainBox" p={'0.5rem'} width={"65vw"}>
                    <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                        <Typography fontWeight={600}>Approvals List</Typography>
                        <Button className='Common_Btn_Min_Width'
                            onClick={() => {
                                onClose();
                                updateState({
                                    approverDatePickerOpen: false,
                                    approverDate: new Date(),
                                    searchApproverList: ''
                                })
                                props.getApproverListData(new Date(), "")
                            }}
                        >
                            <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
                        </Button>
                    </Box>
                    <Box component={'div'} display={'flex'} mb={'0.5rem'}>
                        <TextField
                            autoComplete='off'
                            size='small'
                            sx={{ width: '20vw', mr: '1vw' }}
                            value={state.searchApproverList}
                            onChange={(e) => {
                                updateState({ searchApproverList: e.target.value });
                            }}
                            label={'Search Patient Name'}
                            onKeyDown={(e) => { e.stopPropagation() }}
                        />
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                open={state.approverDatePickerOpen}
                                onOpen={() => { updateState({ approverDatePickerOpen: true }) }}
                                onClose={() => { updateState({ approverDatePickerOpen: false }) }}
                                value={state.approverDate}
                                name={"datePicker"}
                                inputFormat='DD-MM-YYYY'
                                views={["year", "month", "day"]}
                                onChange={(newDate) => {
                                    updateState({ approverDate: newDate });
                                    props.getApproverListData(newDate, state.searchApproverList)
                                }}
                                maxDate={new Date()}
                                renderInput={(params) => <TextField
                                    onKeyDown={(e) => {
                                        e.preventDefault()
                                        e.stopPropagation()
                                    }} style={{ width: '9.5vw' }} size='small' {...params}
                                    inputProps={{ ...params.inputProps, 'emed_tid': 'IP_Date_Search' }}
                                    onClick={() => { updateState({ approverDatePickerOpen: true }) }} />}
                            />
                        </LocalizationProvider>
                    </Box>
                    <Box component={'div'} height={'30dvw'}>
                        <DataGrid
                            rows={state.approverList || []}
                            columns={columns}
                            getRowId={(row) => row.sno}
                            pageSizeOptions={[10, 20, 30]}
                            pagination
                            paginationMode="client"
                            paginationModel={{
                                page: state.approverPage,
                                pageSize: state.approverPageSize
                            }}
                            onPaginationModelChange={(model) => {
                                updateState({
                                    approverPage: model.page,
                                    approverPageSize: model.pageSize
                                })
                            }}
                            loading={approverLoad}
                            localeText={{
                                toolbarColumns: "",
                                toolbarDensity: "",
                                toolbarExport: "",
                                toolbarFilters: "",
                                toolbarExportPrint: ""
                            }}
                            components={{
                                NoRowsOverlay: () => (
                                    <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'}>
                                        {("No Records To Be Shown")}
                                    </Box>
                                )
                            }}
                            headerHeight={40}
                        />
                    </Box>
                </Box>
            </Modal>
        )
    } catch (error) {
        props.errorMessage(error.message)
    }
}, (prevProps, nextProps) => {
    return prevProps.openApproverList === nextProps.openApproverList &&
        prevProps.approverLoad === nextProps.approverLoad &&
        prevProps.approverList === nextProps.approverList;
})

export default ApproverListPopup